import linearTrendline from './linear-trendline';
import movingAverageTrendline from './moving-average';
import { TRENDLINE_LINEAR, TRENDLINE_MOVING_AVERAGE } from '../constants';

const registry = {};
registry[TRENDLINE_LINEAR] = linearTrendline;
registry[TRENDLINE_MOVING_AVERAGE] = movingAverageTrendline;

export default registry;
